export { default as RiotGamesIcon } from '~icons/simple-icons/riotgames';
